module.exports = {
  dimensions: {
    width: 121,
    height: 38
  },
  optical: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  nine: {
    top: 20,
    left: 10,
    right: 10,
    bottom: 10
  },
  content: {
    top: 1,
    left: 6,
    right: 6,
    bottom: 4
  }
};